import { createErrorCodes } from '@shared/utils';
import { LOGGER_MESSAGES } from './LOGGER_MESSAGES';

export const LOGGER_ERROR_CODES = createErrorCodes(LOGGER_MESSAGES);
